import EmptyRouterView from 'src/views/Pages/GeneralViews/EmptyRouterView.vue';
import MasterTab from 'src/components/Layouts/MasterTab.vue';
import LogAccessReport from 'src/views/Pages/Dashboard/Log/LogAccessReport/LogAccessReport.vue';

const LogReportsRoutes = {
    path: 'logreports',
    name: 'audit.log_reports',
    component: MasterTab,
    props: { reference: 'reportsTabs' },
    children: [
        {
            path: 'access',
            component: EmptyRouterView,
            children: [
                {
                    path: '',
                    name: 'audit.access_report',
                    component: LogAccessReport,
                    meta: {
                        prefix_permission: 'logreports_access',
                    },
                },
            ],
        },
    ]
};

export default LogReportsRoutes;